import { render, staticRenderFns } from "./mySwiper.vue?vue&type=template&id=3fdf2754&scoped=true"
import script from "./mySwiper.vue?vue&type=script&lang=js"
export * from "./mySwiper.vue?vue&type=script&lang=js"
import style0 from "./mySwiper.vue?vue&type=style&index=0&id=3fdf2754&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fdf2754",
  null
  
)

export default component.exports